import React from "react";
import { Box, Typography } from "@mui/material";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";

const NoReceiptFound: React.FC = () => {
  const { t } = useKivunovaTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="400px"
      gap={3}
    >
      <Typography variant="h6" color="text.primary" fontWeight="bold">
        {t("no-receipt-found-title", "No receipts found")}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t(
          "no-receipt-found.description",
          "Receipts are typically generated from Payments."
        )}
      </Typography>
    </Box>
  );
};

export default NoReceiptFound;
